export default {
    'title': '即使身在远处 亦能进度在握',
    'md1title': '为你和现场提供『身历其境』的连接',
    'md1c0title': '避免返工浪费',
    'md1c0desc': '在错误发生之前及时发现并解决这些错误。360°鹰眼的空间智能功能可以对设计的BIM模型和构建的全景现场进行比较。',
    'md1c1title': '预防纠纷',
    'md1c1desc': '出现问题时，360°鹰眼 - 数字化智慧工地监管系统上已为您的工作地点提供历史快照记录。',
    'md1c2title': '追踪进度',
    'md1c2desc': '了解何时以及如何完成工作。远程监视专案现场的条件。',
    'md1c3title': '减少现场到访',
    'md1c3desc': '即使不用到现场也能保持团队的生产力。360°鹰眼使您无论身处何方都能检查项目，从所有角度观察，发现质量及安全隐患。',
    'md3desc': '360鹰眼 – 让你不必要到现场，都可以像亲临其境一样进行勘察、全面了解工程，掌握工程概况。鹰眼系统是一种虚拟现场作业环境，您可以从定期的全景照中查看到现场的最新情况，把握最新进度，发现问题',
    'md4title': '让数字孪生最大化你空间的价值',
    'md4desc': '利用360°鹰眼 - 数字化智慧工地监管系统的空间智能功能，并排比较BIM和360°全景图，准确地以3D方式跟踪墙壁，门，窗户等。通过导入点云数据来提高施工的准确性。',
    'md5title': '连接项目的过去与未来',
    'md5d0': '筛选不同时间的现场实景对比，追踪完成情况',
    'md5d1': '利用现场数据分析查看问题数量及完成进度',
    'md5d2': '线上查看现场IOT相关数据',
    'md6title': '快速方便捕获现场实景数据',
    'md6desc': '使用主流品牌的全景相机，在APP中只要几步操作即可上传到360鹰眼-数字化工地监管系统中',
    'md6c0title': '现场采集',
    'md6c0desc': '兼容绝大部分主流品牌全景相机对现场进行拍摄采集通过手机APP上传',
    'md6c1title': '服务器处理',
    'md6c1desc': '服务器通过鹰眼360°算法将采集数据智能处理',
    'md6c2title': '在线浏览',
    'md6c2desc': '项目各方参与人员通过鹰眼360°查看现场实景进行项目管理',
    'md6ctaddr': '联系地址: 香港特别行政区九龙海港城海洋中心9楼901室',
    'md6cttel': '联系电话 : +852 23828380',
    'md6ctemail': '联系邮箱: solution@isbim.com.hk',

}